export const config = {
  /** プロダクト ※「common」「sf」などAPI通信の subject に該当する値 */
  product: 'sf',

  /** ログイン画面へのパス ※未設定だとデフォルト値 */
  // loginPath: '',

  /** 共通エラー画面で表示する「業務メニューへ」ボタンに設定するURL ※未設定だとデフォルト値 */
  // menuUrl: '',

  /** 共通エラー画面で表示する「サポートサイトへ」ボタンに設定するURL ※未設定だとデフォルト値 */
  // supportUrl: ''
};



// WEBPACK FOOTER //
// ./src/configs/config.ts